import React, { useContext, useState, SetStateAction, useEffect } from "react";
import Select from "react-select";
import { ThemeContext } from "../../context/themeContext";

interface options {
  label: string;
  value: string;
}

type SelectType = {
  selectoptions?: Array<options>;
  selected?: options;
  width?: string;
  handleChange?: React.Dispatch<React.SetStateAction<{}>>;
};

export default function SelectComponent({
  selectoptions,
  selected,
  width = "174px",
  handleChange,
}: React.PropsWithChildren<SelectType>) {
  const { theme } = useContext(ThemeContext);
  const [selectedOption, setSelectedOption] = useState<any>(selected);

  useEffect(() => {
    handleChange &&
      handleChange((prevState) => ({
        ...prevState,
        campaign_id: selectedOption.value,
      }));
  }, [selectedOption]);

  const isDark = theme === "dark";

  const customStyles = {
    option: (provided, state) => ({
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      backgroundColor: state.isSelected
        ? isDark
          ? "#D9D9D9"
          : "#808080"
        : "inherit",
      padding: "8px",
      cursor: "pointer",
      fontFamily: "Switzer",
      fontSize: "12px",
      fontWeight: "400",
      color: state.isSelected
        ? isDark
          ? "#000"
          : "#fff"
        : isDark
        ? "#fff"
        : "#000",
      lineHeight: "15.84px",
      ":hover": {
        backgroundColor: state.isSelected
          ? isDark
            ? "#D9D9D9"
            : "#808080"
          : isDark
          ? "#696969"
          : "#D9D9D9",
      },
      ":focus": {
        backgroundColor: state.isSelected
          ? isDark
            ? "#D9D9D9"
            : "#808080"
          : isDark
          ? "#2A2C30"
          : "#D9D9D9",
      },

      ":active": {
        backgroundColor: state.isSelected
          ? isDark
            ? "#D9D9D9"
            : "#808080"
          : isDark
          ? "#2A2C30"
          : "#D9D9D9",
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: theme === "dark" ? "#2A2C30" : "white",
    }),

    control: () => ({
      width: width,
      height: 35,
      border: theme === "dark" ? ".5px solid #4E5966" : ".5px solid #D9D9D9",
      borderRadius: 4,
      fontFamily: "Outfit Regular",
      fontSize: "12px",
      fontWeight: "400",
      color: isDark ? "#fff" : "#000",
      lineHeight: "15.84px",
      display: "flex",
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";
      const color = theme === "dark" ? "white" : "black";

      return { ...provided, opacity, transition, color };
    },
  };

  return (
    <div>
      <Select
        defaultValue={selected}
        onChange={setSelectedOption}
        options={selectoptions}
        isSearchable={false}
        className={`w-[${width}] h-[35px] font-[400] text-[12px] font-switzer leading-[15.84px] rounded-[4px] text-primary-dark bg-background`}
        styles={customStyles}
      />
    </div>
  );
}
